import { Link } from "../components";
import cn from "classnames";
import { oemValues } from "../constants/oem";
import sharedStyles from "../shared.module.scss";
import styles from "./Footer.module.scss";
import { useFormatMessage } from "../i18n";

export function Footer({ className }) {
  const tr = useFormatMessage();

  return (
    <footer className={cn(styles.footer, className)}>
      <div className={cn(styles.footerLinks)}>
        <a
          href={"https://" + oemValues.footerLink}
          className={cn(sharedStyles.link, sharedStyles.secondaryText)}
        >
          © {oemValues.footerLink}
        </a>
        <span style={{ whiteSpace: "pre" }}> &mdash; </span>
        <Link
          to="/terms-and-conditions"
          className={cn(sharedStyles.link, sharedStyles.secondaryText)}
        >
          {tr("terms_and_conditions")}
        </Link>
      </div>
    </footer>
  );
}
